import Map from '@blade-sxp/map/2d/src/Map';
import { EventBus, EventKeys } from '@blade/common';
import onDuty from '@blade/common-ui/map-old/2d/src/assets/staff.png';
import highlight from '@blade/common-ui/map-old/2d/src/assets/highlight.png';
import { MapSate } from '@blade/common-ui/map-old/2d/src/config/mapConfig';
import { ROI_BORDER, ROI_BORDER_TRANSPARENT, ROI_FILL, ROI_TRANSPARENT } from '@blade/common-ui/map-old/2d/src/utils/layerData';
import { DeviceMap, reconvertLocation, getRightPoint } from '@blade/common-ui/map-old/2d/src/utils/tools';
export function addEvents(component) {
    const map = component.map;
    component.map.addEventListener(Map.eventType.layerDataChange, (e) => {
        component.rootLayerData = e.layerData;
    });
    component.map.addEventListener(Map.eventType.mapClick, (e) => {
        const { mapPosition: position } = e;
        if (component.state === MapSate.OnLocation) {
            const verticesToAdd = reconvertLocation(position.x, position.y, component.imageSize);
            EventBus.$emit(EventKeys.MAP_REMARK_DEVICE, { verticesToAdd, device: component.deviceToAdd });
            EventBus.$emit(EventKeys.MAP_REMARK_PERSON, { verticesToAdd, person: component.personToAdd });
        }
    });
    map.addEventListener(Map.eventType.elementClick, (e) => {
        const { type, id, device, person, ZONE_ID, dataType, taskId, details } = e.elementProps;
        component.type = dataType;
        // console.log('elementClick elementProps ', e.elementProps);
        component.onClickElement(e.elementProps);
        if (dataType === 'device') {
            // 编辑摄像头位置
            if (type === 'image' && device && component.state !== MapSate.OnLocation && component.modifyMode) {
                component.state = MapSate.OnLocation;
                component.deviceToAdd = device;
                map.delElement(id);
            }
            if (type === 'image' && component.modifyMode) {
                // 摄像头点击
                const onImgClick = component?.customedEvents?.onImgClick;
                onImgClick && onImgClick(device);
            }
            if (type === 'image' && !component.modifyMode) {
                const { id, name } = e.elementProps.device;
                EventBus.$emit(EventKeys.MAP_CLICK_DEVICE, { id, name });
            }
        }
        if (dataType === 'person') {
            if (details) {
                return;
            }
            if (type === 'image' && person && component.state !== MapSate.OnLocation && component.modifyMode) {
                component.state = MapSate.OnLocation;
                component.personToAdd = person;
                map.delElement(id);
            }
            if (type === 'image' && component.modifyMode) {
                // 摄像头点击
                const onImgPersonClick = component?.customedEvents?.onImgPersonClick;
                onImgPersonClick && onImgPersonClick(person);
            }
            if (type === 'image' && !component.modifyMode) {
                const { id, name } = e.elementProps.person;
                EventBus.$emit(EventKeys.MAP_CLICK_PERSON, { id, name });
            }
        }
        if (type === 'roi') {
            if (dataType === 'hotArea') {
                const onHotAreaClick = component?.customedEvents?.onHotAreaClick;
                onHotAreaClick && onHotAreaClick(taskId);
            }
            else {
                const onRoiClick = component?.customedEvents?.onRoiClick;
                onRoiClick && onRoiClick({ id: ZONE_ID });
            }
        }
    });
    component.map.addEventListener(Map.eventType.elementMouseEnter, (e) => {
        const { type, id, points, ZONE_ID, name, dataType, taskId, polygon, roiText } = e.elementProps;
        switch (type) {
            case 'image':
                if (dataType === 'device') {
                    if (component.state !== MapSate.OnLocation) {
                        component.map.updateProps(id, 'url', highlight);
                    }
                }
                if (dataType === 'person') {
                    if (component.state !== MapSate.OnLocation) {
                        component.map.updateProps(id, 'url', onDuty);
                    }
                }
                break;
            case 'roi':
                const changeMouse = component?.customedEvents?.changeMouse;
                changeMouse && changeMouse(true);
                const right = getRightPoint(points);
                const { x, y } = map.mapPositionToOffset(right.left, right.top);
                const mapDomRef = component.$refs.mapRef;
                const { left, top } = mapDomRef.getBoundingClientRect();
                EventBus.$emit(EventKeys.MAP_ELEMENT_ENTER, {
                    zone: {
                        ZONE_ID,
                        name,
                    },
                    dataType,
                    taskId,
                    position: { left: left + x, top: top + y }
                });
                if (dataType === 'roi') {
                    map.updateProps(id, 'polygon', { ...polygon, color: 'rgba(0,119,250, .8)' });
                }
                else if (dataType === 'hotArea') {
                    map.updateProps(id, 'border', ROI_BORDER);
                    map.updateProps(id, 'roiText', { ...roiText, color: '#ffffff66' });
                }
                break;
            default:
                break;
        }
    });
    component.map.addEventListener(Map.eventType.elementMouseLeave, (e) => {
        const { type, id, device, dataType, polygon, roiText } = e.elementProps;
        if (dataType === 'device') {
            if (type === 'image' && component.state !== MapSate.OnLocation) {
                map.updateProps(id, 'url', DeviceMap[device.status]);
            }
        }
        if (dataType === 'person') {
            if (type === 'image' && component.state !== MapSate.OnLocation) {
                map.updateProps(id, 'url', onDuty);
            }
        }
        if (type === 'roi') {
            const changeMouse = component?.customedEvents?.changeMouse;
            changeMouse && changeMouse(false);
            if (dataType === 'roi') {
                map.updateProps(id, 'polygon', polygon.show ? ROI_FILL : ROI_TRANSPARENT);
            }
            else if (dataType === 'hotArea') {
                map.updateProps(id, 'border', ROI_BORDER_TRANSPARENT);
                map.updateProps(id, 'roiText', { ...roiText, color: '#ffffff00' });
            }
            EventBus.$emit(EventKeys.MAP_ELEMENT_ENTER, null);
        }
    });
    map.addEventListener(Map.eventType.mapDomResize, (e) => {
        const { width, height } = e;
        component.actualSize = { width, height };
    });
}
